/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSchemaEnumData } from '../models/data-schema-enum-data';
import { DataSchemaEnumDataPartial } from '../models/data-schema-enum-data-partial';
import { DataSchemaEnumDataWithRelations } from '../models/data-schema-enum-data-with-relations';
import { NewDataSchemaEnumData } from '../models/new-data-schema-enum-data';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class DataSchemaEnumDataControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation dataSchemaEnumDataControllerCount
   */
  static readonly DataSchemaEnumDataControllerCountPath = '/data-schema-enum-data/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataSchemaEnumDataControllerService.DataSchemaEnumDataControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataSchemaEnumDataControllerFindById
   */
  static readonly DataSchemaEnumDataControllerFindByIdPath = '/data-schema-enum-data/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<DataSchemaEnumData>> {

    const rb = new RequestBuilder(this.rootUrl, DataSchemaEnumDataControllerService.DataSchemaEnumDataControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataSchemaEnumData>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<DataSchemaEnumData> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<DataSchemaEnumData>) => r.body as DataSchemaEnumData)
    );
  }

  /**
   * Path part for operation dataSchemaEnumDataControllerDeleteById
   */
  static readonly DataSchemaEnumDataControllerDeleteByIdPath = '/data-schema-enum-data/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataSchemaEnumDataControllerService.DataSchemaEnumDataControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataSchemaEnumDataControllerUpdateById
   */
  static readonly DataSchemaEnumDataControllerUpdateByIdPath = '/data-schema-enum-data/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: DataSchemaEnumDataPartial
  }): Observable<StrictHttpResponse<DataSchemaEnumData>> {

    const rb = new RequestBuilder(this.rootUrl, DataSchemaEnumDataControllerService.DataSchemaEnumDataControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataSchemaEnumData>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: DataSchemaEnumDataPartial
  }): Observable<DataSchemaEnumData> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<DataSchemaEnumData>) => r.body as DataSchemaEnumData)
    );
  }

  /**
   * Path part for operation dataSchemaEnumDataControllerFind
   */
  static readonly DataSchemaEnumDataControllerFindPath = '/data-schema-enum-data';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<DataSchemaEnumDataWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, DataSchemaEnumDataControllerService.DataSchemaEnumDataControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataSchemaEnumDataWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<DataSchemaEnumDataWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataSchemaEnumDataWithRelations>>) => r.body as Array<DataSchemaEnumDataWithRelations>)
    );
  }

  /**
   * Path part for operation dataSchemaEnumDataControllerCreate
   */
  static readonly DataSchemaEnumDataControllerCreatePath = '/data-schema-enum-data';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewDataSchemaEnumData
  }): Observable<StrictHttpResponse<DataSchemaEnumData>> {

    const rb = new RequestBuilder(this.rootUrl, DataSchemaEnumDataControllerService.DataSchemaEnumDataControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataSchemaEnumData>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewDataSchemaEnumData
  }): Observable<DataSchemaEnumData> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<DataSchemaEnumData>) => r.body as DataSchemaEnumData)
    );
  }

}
